import type {PaletteMode} from '@mui/material';
import createTheme from '@mui/material/styles/createTheme';
import {lighten} from '@mui/system/colorManipulator';

export const primaryColor = '#7e6a5c';
export const FIELD_COLOR = 'hsl(337, 155%, 27%)';
export const FIELD_LABEL_COLOR = 'hsl(337, 155%, 12%)';

const theme = (mode?: PaletteMode) =>
  createTheme({
    palette: {
      mode: mode ? mode : 'light',
      primary: {
        main: primaryColor,
        contrastText: '#fff',
      },
      secondary: {
        main: FIELD_COLOR,
        dark: FIELD_LABEL_COLOR,
      },
      text: {
        primary: '#000000',
        secondary: '#746F81',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          /* Firefox Scrollbar */
          body: {
            scrollbarColor: `${lighten(primaryColor, 0.5)} transparent` /* scroll thumb and track */,
            scrollbarWidth: '2px',
          },
          /* Chrome Scrollbar */
          '*::-webkit-scrollbar': {
            width: '0.2em',
            height: '0.15em',
          },
          '*::-webkit-scrollbar-track': {
            WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: lighten(primaryColor, 0.5),
            opacity: 0.2,
            outline: '0px solid slategrey',
          },
        },
      },
    },
  });

export default theme;
